<template>
  <div class="text-no-wrap">
    <template v-if="useDialog">
      <a :href="messageURL"
         @click.prevent="fetchData">
        {{ message.created_at | datetime(dateFormat) }}
      </a>
      <v-dialog v-model="dialog"
                max-width="90%">
        <v-sheet>
          <v-toolbar color="primary"
                     dark
                     flat
                     tile>
            <v-toolbar-title>
              {{ message.subject }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   dark
                   @click="closeDialog">
              <v-icon>
                fal fa-times
              </v-icon>
            </v-btn>
          </v-toolbar>
          <MessageCard :message="localMessage"
                       :flat="true"
                       :tile="true">
          </MessageCard>
        </v-sheet>
      </v-dialog>
    </template>
    <router-link v-else
                 :to="{name: `${$root.routePrefix}.mailgun.message`, params: {messageID: message.b64_id}, query: $route.query}">
      {{ message.created_at | datetime(dateFormat) }}
    </router-link>
  </div>
</template>
<script>
import MessageCard from './MessageCard';
import mailgunService from '../../../../../ml/services/mailgunService';

export default {
  components: {MessageCard},
  props: {
    message: {
      type: Object,
      required: true,
    },
    useDialog: {
      type: Boolean,
      default: false,
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD h:mm a',
    }
  },
  data() {
    return {
      dialog: false,
      localMessage: null,
    }
  },
  computed: {
    messageURL() {
      const route = this.$router.resolve({name: `${this.$root.routePrefix}.mailgun.message`, params: {messageID: this.message.id}});
      return route.href;
    },
  },
  methods: {
    fetchData() {
      mailgunService.getMessage(this.message.id)
        .then(message => {
          this.localMessage = message;
          this.dialog = true;
        })
    },
    closeDialog() {
      this.dialog = false;
    }
  }
}
</script>
